/**
 * @description A context that provides a reference to the footer section of the application layout, so it can easily
 *  be shared to any component in the application.
 */

import React from 'react';
import { PropTypes } from 'prop-types';

export const FooterContext = React.createContext(null);

/**
 * @prop children {React.Element | React.Element[]} - react elements to wrap the provider in
 * @prop footerRef {React.RefObject<*>} - reference to the footer element
 */
export const FooterProvider = ({ children, footerRef }) => {
  const [footerEl, setFooterEl] = React.useState(null);

  /**
   * Sets the footer element state based on the reference passed in.
   *
   * Its important to use react state when registering the reference so that any components that depend on the
   * rooter element to be defined will be re-rendered once the reference is defined.
   */
  React.useEffect(() => {
    setFooterEl(footerRef.current);
  }, []);

  return (
    <FooterContext.Provider value={footerEl}>
      {children}
    </FooterContext.Provider>
  );
};

FooterProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  footerRef: PropTypes.shape({ current: PropTypes.object }).isRequired
};
